import { useQuery } from 'react-query';

import getCart from '@/common/api/carts/getCart';
import { ENDPOINT_CARTS } from '@/common/constants';

export const getQueryKey = (id, setDefault = true) => [
  ENDPOINT_CARTS,
  `${id ?? ''}`,
  setDefault,
];

const useCart = ({ id, setDefault = true, disabled = false, source }) =>
  useQuery(getQueryKey(id, setDefault, source), getCart, {
    enabled: !!id && !disabled,
    keepPreviousData: true,
  });

export default useCart;
